import React from "react";
import { useGlobalState } from "../../helpers/GlobalStateProvider";
import { useModalState } from "../../helpers/ModalProvider";
import { Link, Stack, Text } from "@chakra-ui/react";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

export const WhatIsStakingModal: React.FC = () => {
  // 1) Access any global logic you need (like staking):
  const { stakeMorAndConnectWallet } = useGlobalState();

  // 2) Access the modal's visibility from the modal provider:
  const { isWhatIsModalVisible, setWhatIsModalVisible } = useModalState();

  const handleClose = () => {
    setWhatIsModalVisible(false);
  };

  const closeAndStake = () => {
    // Close the modal first, then do the stake logic
    handleClose();
    stakeMorAndConnectWallet(1, false);
  };

  return (
    <DialogRoot
      lazyMount
      open={isWhatIsModalVisible}
      onOpenChange={(e) => setWhatIsModalVisible(e.open)}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>What is MOR Staking?</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Stack gap={4}>
            <Text>
              Morpheus is building the world’s first open-source, peer-to-peer
              network of personal, general-purpose AI—powered by the MOR token.
            </Text>
            <Text>
              Now, you can support CoinCap and gain full access to our
              crypto-data API simply by staking your MOR tokens with us on the
              Base network. Every MOR you stake helps strengthen and grow
              CoinCap, ensuring we can continue to deliver top-tier data and
              services.
            </Text>
            <Text>
              In return, you’ll get access to our world-class API, earn
              valuable CoinCap Points, and receive a 10% APR on all MOR tokens
              staked.*
            </Text>
            <Text>
              For a limited time, we’re offering an additional 5% APR*—bringing
              your total to 15%! Don’t miss this chance to maximize your
              rewards and support the future of CoinCap.
            </Text>
            <Link
              href="https://mor.org/"
              target="_blank"
              rel="noopener noreferrer"
              color="#9333ea"
              fontWeight={600}
            >
              Learn more about Morpheus
            </Link>
          </Stack>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Close
          </Button>
          <Button colorPalette="purple" bg="#9333ea" onClick={closeAndStake}>
            Stake MOR
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
